import { render, staticRenderFns } from "./OrderBarrelOptionsCarousel.vue?vue&type=template&id=8c16efba&"
import script from "./OrderBarrelOptionsCarousel.vue?vue&type=script&lang=js&"
export * from "./OrderBarrelOptionsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./OrderBarrelOptionsCarousel.vue?vue&type=style&index=0&id=8c16efba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports